import {
  getSavingsDetails,
  getSavingsTotal,
} from '@/common/integrations/menhir/employee/savings/savings.service';
import { TSavingsFull } from '@/common/integrations/menhir/employee/savings/savings.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { TMoney } from '@coverflex-tech/hypernova-utils';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

export const useGetSavingsTotal = (options?: UseQueryOptions<TMoney, any>) => {
  const { data: savings, ...rest } = useQuery<TMoney>({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.SAVINGS, 'simple'],
    queryFn: getSavingsTotal,
    ...options,
  });

  return { savings, ...rest };
};

export const useGetSavingsDetails = (
  monthYear?: {
    month?: number;
    year?: number;
  },
  options?: UseQueryOptions<TSavingsFull, any>
) => {
  const { data: savingsDetails, ...rest } = useQuery<TSavingsFull>({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.SAVINGS,
      'full',
      monthYear?.month,
      monthYear?.year,
    ],
    queryFn: () => getSavingsDetails(monthYear),
    ...options,
  });

  return { savingsDetails, ...rest };
};
